import { render, staticRenderFns } from "./AllCountryFarmerGroup.vue?vue&type=template&id=189aedd8&scoped=true&"
import script from "./AllCountryFarmerGroup.vue?vue&type=script&lang=js&"
export * from "./AllCountryFarmerGroup.vue?vue&type=script&lang=js&"
import style0 from "./AllCountryFarmerGroup.vue?vue&type=style&index=0&id=189aedd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189aedd8",
  null
  
)

export default component.exports